import { useSiren } from '@shared/contexts/siren-context';
import { CSVLink } from 'react-csv';
import { Button, ButtonMarkup, Icon, IconName, IconSize } from '@bytel/trilogy-react-ts';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GraphExporterProps } from './type';

const GraphExporter = ({ data, headers, filename, exportType }: GraphExporterProps): React.ReactElement => {
  const siren = useSiren();

  const { t } = useTranslation('domain/home', { keyPrefix: 'consommationFlotte' });

  const now = new Date();
  const date = `${now.getUTCDate()}_${now.toLocaleString('default', { month: '2-digit' })}_${now.getUTCFullYear()}`;
  const defaultFilename = `export-${exportType || 'data'}-${siren?.id}-${date}.csv`;

  const csvLinkRef = useRef<CSVLink>(null);

  return (
    <>
      <CSVLink
        data={data}
        separator=";"
        headers={headers}
        filename={filename || defaultFilename}
        className="has-text-primary"
        data-cy="graphExporter-csvLink"
        ref={csvLinkRef}
      />
      <Button
        className="is-primary has-background-grey-light has-text-primary has-icon"
        markup={ButtonMarkup.BUTTON}
        data-cy="home-boxConsommationFlotte-graphExporter"
        onClick={() => csvLinkRef.current?.link.click()}
      >
        <Icon name={IconName.DOWNLOAD} size={IconSize.SMALL} />
        {t('export.download')}
      </Button>
    </>
  );
};

GraphExporter.defaultProps = {
  filename: undefined,
  exportType: undefined,
};

export default GraphExporter;
